import React from "react";
import moment from "moment";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { History } from "history";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import { PictureAsPdf, ArrowBack } from "components/Icons";
import Button from "components/Button";
import DetailsCard from "./DetailsCard";
import InvoiceLines from "./InvoiceLines";
import InvoiceDeliveries from "./InvoiceDeliveries";
import { connect } from "../../../reduxConnector";
import InvoiceActions from "../actions";
import { downloadDocument } from "helpers/download";
import { getRoleId } from "helpers/formatting";
import { URLS } from "constants/urlConstants";

import "./style.scss";

interface IProps {
  roles: string[];
  getInvoice: (invoiceId: number) => void;
  getInvoiceLines: (invoiceId: number, roleId: string) => void;
  getInvoiceDeliveries: (invoiceId: number, roleId: string) => void;
  currentItem: any;
  isLoading: boolean;
  invoiceLines: any;
  invoiceDeliveries: any;
  match: any;
  history: History;
}

class InvoiceDetails extends React.Component<IProps> {
  public componentDidMount() {
    const {
      match: {
        params: { id }
      },
      getInvoice
    } = this.props;

    getInvoice(id);
  }

  private getRoleId = currentItem => {
    return getRoleId(currentItem.PurchaseType, currentItem.DerivativeOrder);
  };

  private onDeliveryClick = rowData => {
    this.props.history.push(
      `${URLS.DELIVERIES_URL}/${rowData.Id}?kooptype=${rowData.RoleId}`
    );
  };

  public render() {
    const {
      roles,
      currentItem,
      invoiceLines,
      getInvoiceLines,
      isLoading,
      invoiceDeliveries,
      getInvoiceDeliveries,
      history
    } = this.props;

    if (!currentItem) {
      return null;
    }

    return (
      <div id="invoice-details-page">
        <h1>
          <ArrowBack onClick={() => history.back()} />
          <FormattedMessage id="INVOICES_DETAILS" />
        </h1>
        <div className="title-raw">
          <div className="title-raw-info">
            <div>
              <FormattedMessage id="INVOICES_NUMBER" tagName="h3" />
              <h2>{currentItem.Number}</h2>
            </div>
            <div>
              <FormattedMessage id="INVOICES_DATE" tagName="h3" />
              <h2>{moment(currentItem.InvoiceDate).format("DD-MM-YYYY")}</h2>
            </div>
            <div>
              <FormattedMessage id="STATUS" tagName="h3" />
              {currentItem.RemainingAmount === 0 ? (
                <FormattedMessage id="CLOSED" tagName="h2" />
              ) : (
                <FormattedMessage id="OPEN" tagName="h2" />
              )}
            </div>
          </div>
        </div>

        <DetailsCard
          currentItem={currentItem}
          onOrderClick={() =>
            history.push(
              `${URLS.ORDERS_URL}/${
                currentItem.Order.Id
              }?kooptype=${this.getRoleId(currentItem)}`
            )
          }
          isOrderClickable={_.includes(roles, "Orders")}
        />

        <div className="download-button-wrapper">
          <Button
            id={`download-invoice-${_.get(
              currentItem,
              "DocumentId",
              "no_document"
            )}.pdf`}
            icon={<PictureAsPdf />}
            onClick={() => downloadDocument(currentItem)}
          >
            INVOICES_DOWNLOAD
          </Button>
        </div>
        <Tabs>
          <TabList>
            <Tab>
              <FormattedMessage id="INVOICES_LINES" />
            </Tab>
            {_.includes(roles, "Financieel") && (
              <Tab>
                <FormattedMessage id="DELIVERIES_HEADER" />
              </Tab>
            )}
          </TabList>
          <hr />
          <TabPanel>
            <InvoiceLines
              isLoading={isLoading}
              data={invoiceLines}
              loadData={() =>
                getInvoiceLines(currentItem.Id, this.getRoleId(currentItem))
              }
            />
          </TabPanel>
          {_.includes(roles, "Financieel") && (
            <TabPanel>
              <InvoiceDeliveries
                isLoading={isLoading}
                data={invoiceDeliveries}
                loadData={() =>
                  getInvoiceDeliveries(
                    currentItem.Id,
                    this.getRoleId(currentItem)
                  )
                }
                onRowClick={this.onDeliveryClick}
              />
            </TabPanel>
          )}
        </Tabs>
      </div>
    );
  }
}

export default connect(
  state => ({
    roles: state.app.roles,
    currentItem: state.invoices.currentItem,
    isLoading: state.invoices.isLoading,
    invoiceLines: state.invoices.invoiceLines,
    invoiceDeliveries: state.invoices.invoiceDeliveries
  }),
  {
    getInvoice: InvoiceActions.getInvoice,
    getInvoiceLines: InvoiceActions.getInvoiceLines,
    getInvoiceDeliveries: InvoiceActions.getInvoiceDeliveries
  }
)(InvoiceDetails);
